import React from 'react';
import { Calendar } from 'lucide-react';

interface DateRangeFilterProps {
  startDate: string | undefined | null;
  endDate: string | undefined | null;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onClear?: () => void;
  className?: string;
  label?: string;
  vertical?: boolean;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear,
  className = '',
  label = 'Filter by Date',
  vertical = false
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    } else {
      onStartDateChange('');
      onEndDateChange('');
    }
  };

  return (
    <div className={`flex ${vertical ? 'flex-col' : 'flex-col sm:flex-row items-start sm:items-center'} gap-2 ${className}`}>
      {label && <span className="text-sm font-medium text-gray-700 mr-2">{label}:</span>}
      <div className={`flex ${vertical ? 'flex-col items-stretch' : 'items-center'} gap-2 w-full sm:w-auto`}>
        <div className="relative flex-1 sm:flex-none">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Calendar className="h-4 w-4 text-gray-400" />
          </div>
          <input
            type="date"
            value={startDate || ''}
            onChange={(e) => onStartDateChange(e.target.value)}
            className="pl-10 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm h-9"
            placeholder="From"
            aria-label="Start Date"
          />
        </div>
        
        {vertical ? (
           <span className="text-gray-400 text-xs text-center">to</span>
        ) : (
          <span className="text-gray-500">-</span>
        )}
        
        <div className="relative flex-1 sm:flex-none">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Calendar className="h-4 w-4 text-gray-400" />
          </div>
          <input
            type="date"
            value={endDate || ''}
            onChange={(e) => onEndDateChange(e.target.value)}
            className="pl-10 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm h-9"
            placeholder="To"
            aria-label="End Date"
          />
        </div>
        {(startDate || endDate) && (
          <button
            onClick={handleClear}
            className={`text-xs text-red-600 hover:text-red-800 ${vertical ? 'mt-1 text-right' : 'ml-1 whitespace-nowrap'}`}
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
};

export default DateRangeFilter;
